// LeaveTypeSection.tsx

import { TSTitleCard } from '@/components/shared/card/Card';
import { useLeaveTypes } from '@/services/leaveManagement/LeaveTypesProvider';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import strings from '../admin.translations';
import AdminAddLeaveTypeModal from './AdminAddLeaveTypeModal';
import AdminLeaveTypeTable from './AdminLeaveTypeTable';

interface AdminLeaveTypeSectionProps {
  isAdvanced: boolean;
}

export const AdminLeaveTypeSection: FC<AdminLeaveTypeSectionProps> = ({ isAdvanced }) => {
  const [addLeaveTypeModalOpen, setAddLeaveTypeModalOpen] = useState(false);

  const navigate = useNavigate();

  const leaveTypes = useLeaveTypes();

  const onEdit = (id: string) => {
    navigate(`${id}`);
  };

  return (
    <>
      <TSTitleCard
        title={strings.leaveTypeSection.title}
        primaryAction={
          isAdvanced
            ? {
                label: strings.leaveTypeSection.table.addNew,
                onClick: () => setAddLeaveTypeModalOpen(true),
                icon: 'add'
              }
            : undefined
        }
      >
        <AdminLeaveTypeTable leaveTypes={leaveTypes} isAdvanced={isAdvanced} onEdit={onEdit} />
      </TSTitleCard>

      <AdminAddLeaveTypeModal open={addLeaveTypeModalOpen} onClose={() => setAddLeaveTypeModalOpen(false)} />
    </>
  );
};
